import { ChannelAccountChannel } from '../../connectors/types/channelAccount';
import { ConversationParticipantOption } from '../types/Conversation';

export const contactChannelTypeToAccountChannel = (
  contactChannelType?: ConversationParticipantOption['contactChannelType'],
): ChannelAccountChannel | null => {
  switch (contactChannelType) {
    case 'whatsApp':
    case 'phone':
      return 'WhatsApp';
    case 'instagram':
      return 'Instagram';
    case 'telegram':
      return 'Telegram';
    case 'messenger':
      return 'Messenger';
    case 'tikTok':
      return 'TikTok';
    case 'other':
      return 'Webchat';
    case 'email':
      return 'Email';
    default:
      return null;
  }
};

export const requiresChannelAccountForExternalCreate = (
  contactChannelType?: ConversationParticipantOption['contactChannelType'],
): boolean => contactChannelTypeToAccountChannel(contactChannelType) !== null;
